import { Dialog as DSDialog, Text as DSText, Box } from '@digibee/beehive-ui';
import { Button as DSButton } from '@heroui/react';
import React from 'react';

import i18n from '~/common/helpers/i18n';
import { EnvironmentTag } from '~/components/EnvironmentTag';
import { Deployment } from '~/entities/Deployment';

type ModalRollbackProps = {
  closeModalRollback: () => void;
  deployment: Deployment;
  isDeleteRollback: boolean;
  rollbackDeploy: () => void;
  loadingRollback: boolean;
};

const ModalRollback: React.FC<ModalRollbackProps> = ({
  closeModalRollback,
  deployment,
  isDeleteRollback,
  rollbackDeploy,
  loadingRollback
}) => (
  <DSDialog.Root open onOpenChange={() => closeModalRollback()}>
    {/* @ts-expect-error */}
    <DSDialog.Content css={{ padding: '$3' }}>
      <Box css={{ marginBottom: '$3' }}>
        <EnvironmentTag />
      </Box>
      <DSDialog.Header>
        <DSText as='h1' variant='h4'>
          {i18n.t('label.rollback_pipe_deploy_prompt', {
            pipeName: deployment.pipeline.name
          })}
        </DSText>
      </DSDialog.Header>
      <DSText variant='b2'>
        {isDeleteRollback
          ? i18n.t('label.rollback_delete_pipe_deploy_msg')
          : i18n.t('label.rollback_pipe_deploy_msg')}
      </DSText>

      <DSDialog.Footer>
        <DSButton
          isLoading={loadingRollback}
          onPress={() => rollbackDeploy()}
          color='primary'
          data-testid='run-confirm-rollback'
        >
          {i18n.t('action.continue')}
        </DSButton>
        <DSDialog.Close asChild>
          <DSButton
            onPress={() => closeModalRollback()}
            data-testid={`run-cancel-rollback-${deployment.id}`}
          >
            {i18n.t('scenes.design.labels.upper_and_capitalize.uppercase', {
              item: `${i18n.t('scenes.design.actions.cancel')}`
            })}
          </DSButton>
        </DSDialog.Close>
      </DSDialog.Footer>
    </DSDialog.Content>
  </DSDialog.Root>
);

export default ModalRollback;
